"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var keyframes_exports = {};
__export(keyframes_exports, {
  CubicKeyframe: () => CubicKeyframe,
  KeyframeTrack: () => KeyframeTrack,
  LinearKeyframe: () => LinearKeyframe,
  MoveKeyframe: () => MoveKeyframe,
  SpringKeyframe: () => SpringKeyframe
});
module.exports = __toCommonJS(keyframes_exports);
function LinearKeyframe(to, options) {
  return {
    kind: "linear",
    to,
    duration: options.duration,
    timingCurve: options.timingCurve
  };
}
function SpringKeyframe(to) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return {
    kind: "spring",
    to,
    ...options
  };
}
function CubicKeyframe(to, options) {
  return {
    kind: "cubic",
    to,
    ...options
  };
}
function MoveKeyframe(to) {
  return {
    kind: "move",
    to
  };
}
function KeyframeTrack(keyPath, content) {
  if (typeof keyPath === "string") return {
    kind: "track",
    keyPath,
    content: content !== null && content !== void 0 ? content : []
  };
  return {
    kind: "track",
    content: keyPath
  };
}
//# sourceMappingURL=keyframes.js.map
